import InsightsTooltip from 'components/ReusableComponents/Charts/Inslghts/InsightsTooltip'
import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import SmartDatepicker from 'components/ReusableComponents/SmartDatepicker'
import Toggle from 'components/ReusableComponents/Toggle'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import engagementApi from 'services/api/engagement'

import styles from './EmployeePerformanceDialog.module.scss'

const colors = [
  '#10B981',
  '#A855F7',
  '#84CC16',
  '#EC4899',
  '#F43F5E',
  '#22C55E',
  '#0EA5E9',
  '#EF4444'
]

const EmployeePerformanceDialog = ({
  onCloseClick,
  hotelIds,
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {
  const [employeesOriginal, setEmployeesOriginal] = useState()
  const [employees, setEmployees] = useState([])

  const [chartData, setChartData] = useState()

  useEffect(() => {
    engagementApi
      .agentDetails({
        subsidiaryIds: hotelIds,
        fromDate: startDate.format('YYYY-MM-DD'),
        toDate: endDate.format('YYYY-MM-DD')
      })
      .then(data => {
        const employees = Object.values(data)[0].map(d => d.dashboardUserName)

        setEmployees(employees)
        setEmployeesOriginal(employees)

        const graphData = Object.keys(data).map(date => ({
          name: moment(date).format('MMM D'),
          ...data[date].reduce(
            (prev, curr) => ({
              ...prev,
              [curr.dashboardUserName]: curr.totalMessagesSent
            }),
            {}
          )
        }))

        setChartData(graphData)
      })
  }, [startDate, endDate, hotelIds])

  if (!chartData) {
    return null
  }

  return (
    <Dialog>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2 className={styles.dialogTitle}>Employee Performance</h2>
          <SmartDatepicker
            localstorageName="performance-reports"
            startDate={startDate}
            endDate={endDate}
            onChangeStartDate={setStartDate}
            onChangeEndDate={setEndDate}
          />
          <button onClick={onCloseClick} className={styles.closeButton}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.graphHolder}>
            <p className={styles.chartLabel}>Messages</p>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width="100%"
                height={250}
                data={chartData.slice(0, 10)}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 15
                }}
              >
                <CartesianGrid stroke="#F2F2F2" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(0, 14)'
                  }}
                  tickSize={0}
                  padding={{ top: 30, bottom: 20, right: 40 }}
                />
                <YAxis
                  tickSize={0}
                  axisLine={false}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(-10, 0)'
                  }}
                  domain={['dataMin', 'dataMax']}
                  padding={{ top: 40, bottom: 0 }}
                />
                <Tooltip
                  content={<InsightsTooltip />}
                  cursor={{
                    stroke: 'red',
                    strokeWidth: 0,
                    fill: '#dedede',
                    opacity: 0.22
                  }}
                />
                {employeesOriginal.map((name, i) => (
                  <Line
                    visibility={employees.includes(name) ? 'visible' : 'hidden'}
                    type="monotone"
                    dataKey={name}
                    stroke={colors[i]}
                    isUpdateAnimationActive={false}
                    isAnimationActive={false}
                    activeDot={{ r: 8 }}
                    strokeWidth={2}
                    visi
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className={styles.legends}>
            {employeesOriginal.map((name, i) => (
              <div className={styles.legend}>
                <svg width={14} height={14}>
                  <rect width={14} height={14} fill={colors[i]} />
                </svg>
                <span>{name}</span>
                <Toggle
                  mini
                  className={styles.toggle}
                  checked={employees.includes(name)}
                  handleChange={e =>
                    setEmployees([
                      ...employees.filter(i => i !== name),
                      ...(e.target.checked ? [name] : [])
                    ])
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default EmployeePerformanceDialog
